import { render, staticRenderFns } from "./MozFormGroup.vue?vue&type=template&id=0b31096a&scoped=true&"
import script from "./MozFormGroup.vue?vue&type=script&lang=js&"
export * from "./MozFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./MozFormGroup.vue?vue&type=style&index=0&id=0b31096a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31096a",
  null
  
)

export default component.exports